<template>
  <div class="carousel-card">
    <h3 :class=" product.name.length < 15 ? 'carousel-card__short-name' : '' ">
      {{ product.name }}
    </h3>
    <h2 v-if="!isCoagraWeb">
      <vue-numeric
        currency="$"
        separator="."
        :value="product.kilogram_price"
        :precision="0"
        :read-only="true"
      />
      x kg
    </h2>
    <div
      v-if="!isCoagraWeb"
      class="label label-price"
    >
      Sub total:
      <vue-numeric
        currency="$"
        :precision="0"
        separator="."
        :read-only="true"
        :value="subtotal"
      />
    </div>
    <div class="carousel-card__address">
      <div class="pin-icon" />
      <span v-if="product.address">Puesto: {{ product.address }}</span>
      <span v-else>Puesto no especificado</span>
    </div>
    <div class="carousel-card__tags">
      <span
        class="carousel-card__tag"
        v-if="product.form"
      >{{ translate(product.form) }}</span>
      <span
        class="carousel-card__tag"
        v-if="product.packaging"
      >{{ translate(product.packaging) }}</span>
    </div>
    <div class="carousel-card__tons">
      <ev-select
        v-model="selectedTonsOption"
        :options="tonsSelectOptions"
        :on-change="setSelectedTons"
        :disabled="tonsLocked"
      />
    </div>
    <div class="btns">
      <div
        class="btn btn-outline"
        @click="show()"
      >
        Ficha
      </div>
      <button
        class="btn"
        @click="checkIfAuth"
      >
        Continuar
      </button>
    </div>
  </div>
</template>

<script>
import VueNumeric from 'vue-numeric';
import evSelect from './ev-select.vue';
import helpers from './helpers';

function initialTonsFromQuery(productId) {
  const params = new URLSearchParams(window.location.search);
  if (String(params.get('product')) !== String(productId)) return null;

  return params.get('tons');
}

export default {
  components: {
    VueNumeric,
    evSelect,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedTons: helpers.productInitialTons(
        this.product,
        initialTonsFromQuery(this.product.id)
      ),
    };
  },
  computed: {
    tonsLocked() {
      return helpers.fixedPresentationTons(this.product) != null;
    },
    tonsOptions() {
      return helpers.productTonsOptions(this.product);
    },
    tonsSelectOptions() {
      return this.tonsOptions.map(tons => helpers.formatProductTons(tons));
    },
    selectedTonsOption: {
      get() {
        return helpers.formatProductTons(this.selectedTons);
      },
      set(value) {
        this.setSelectedTons(value);
      },
    },
    subtotal() {
      return this.product.kilogram_price * this.selectedTons * 1000;
    },
    loggedIn() {
      return this.$store.state.loggedIn;
    },
    isCoagraWeb() {
      return this.$store.state.order.isCoagraWeb;
    },
  },
  methods: {
    setSelectedTons(value) {
      if (!value || this.tonsLocked) return;
      const parsed = helpers.parseProductTons(value);
      if (this.tonsOptions.includes(parsed)) this.selectedTons = parsed;
    },
    newOrderPath() {
      const basePath = `/order/new?product=${this.product.id}&tons=${this.selectedTons}`;
      let path = basePath;
      if (this.$store.state.order.isColunWeb) path = `${basePath}&tenant=colun`;
      else if (this.$store.state.order.isCoagraWeb) path = `${basePath}&tenant=coagra`;

      return helpers.appendModifyOrderId(path);
    },
    checkIfAuth() {
      if (this.loggedIn) {
        this.goToNewOrder();
      } else {
        this.$store.state.nextPath = this.newOrderPath();
        this.showAuthModal();
      }
    },
    showAuthModal() {
      this.$modal.show('auth-modal');
    },
    goToNewOrder() {
      window.location.href = this.newOrderPath();
    },
    show() {
      this.$modal.show('conditional-modal', {
        product: this.product,
        tons: this.selectedTons,
      });
    },
    hide() {
      this.$modal.hide('conditional-modal');
    },
    translate(word) {
      return helpers.translate(word);
    },
  },
};
</script>
